<template>
  <div>
    <h6 class="card-title">برنامه‌ با حداکثر ۳ مقصد (هر دقیقه)(ریال)</h6>
    <table
      class="table table-head-custom table-head-bg table-borderless table-vertical-center"
    >
      <thead>
        <tr>
          <th v-for="(label, index) in pricesbase.labels_base" :key="index">
            {{ getDifference(label.start, label.end) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(label, index) in pricesbase.labels_base" :key="index">
            {{ numberFormat(pricesbase.live_base[index]) }}
          </td>
        </tr>
      </tbody>
    </table>
    <hr />
    <h6 class="card-title">مقصد اضافه (هر دقیقه)(ریال)</h6>
    <table
      class="table table-head-custom table-head-bg table-borderless table-vertical-center"
    >
      <thead>
        <tr>
          <th
            v-for="(label, index) in pricesdestination.labels_destination"
            :key="index"
          >
            {{ getDifference(label.start, label.end) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            v-for="(label, index) in pricesdestination.labels_destination"
            :key="index"
          >
            {{ numberFormat(pricesdestination.live_destination[index]) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "calculator",
  props: {
    prices: Object
  },
  data() {
    return {
      time: "",
      destinationNumber: "",
      space: "",
      result: null,
      resultCloudly: null,
      labels_base: [],
      timeIndex: {
        0: "نیمه شب",
        1: "1 نیمه شب",
        2: "2 نیمه شب",
        3: "3 نیمه شب",
        4: "4 بامداد",
        5: "5 بامداد",
        6: "6 بامداد",
        7: "7 بامداد",
        8: "8 بامداد",
        9: "9 بامداد",
        10: "10 بامداد",
        11: "11 بامداد",
        12: "12 ظهر",
        13: "1 بعد اظهر",
        14: "2 بعداظهر",
        15: "3 بعداظهر",
        16: "4 بعداظهر",
        17: "5 بعداظهر",
        18: "6 بعداظهر",
        19: "7 شب",
        20: "8 شب",
        21: "9 شب",
        22: "10 شب",
        23: "11 شب",
        24: "12 شب"
      }
    };
  },
  computed: {
    pricesbase() {
      let live_base = [];
      let labels_base = [];
      let start_base = 0;
      for (let i = 0; i < this.prices.live_base?.length; i++) {
        if (this.prices?.live_base[i] != this.prices?.live_base[i + 1]) {
          labels_base.push({ start: start_base, end: i + 1 });
          live_base.push(this.prices.live_base[i]);
          start_base = i + 1;
        }
      }
      return { live_base, labels_base };
    },
    pricesdestination() {
      let live_destination = [];
      let labels_destination = [];
      let start_destination = 0;
      for (let i = 0; i < this.prices.live_destination?.length; i++) {
        if (
          this.prices?.live_destination[i] !=
          this.prices?.live_destination[i + 1]
        ) {
          labels_destination.push({ start: start_destination, end: i + 1 });
          live_destination.push(this.prices.live_destination[i]);
          start_destination = i + 1;
        }
      }
      return { live_destination, labels_destination };
    }
  },
  methods: {
    getDifference(a, b) {
      if (b - a == 24) {
        return "کل روز";
      }
      return `${this.timeIndex[a]} - ${this.timeIndex[b]}`;
    }
  }
};
</script>
